// FNV-1a: synchronous and dependency-free, so it runs in the browser too. Not cryptographically
// strong — for a stable fingerprint or bucket, not anything security-sensitive.
export const fnv1a = (value: string): number => {
  let hash = 0x811c9dc5;
  for (let i = 0; i < value.length; i++) {
    hash ^= value.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
};

export const fnv1aHex = (value: string): string => fnv1a(value).toString(16).padStart(8, '0');
